import { requestData, receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const CLOUD_CONTENT_PENDING = 'CLOUD_CONTENT_PENDING'
export const CLOUD_CONTENT_SUCCESS = 'CLOUD_CONTENT_SUCCESS'
export const CLOUD_CONTENT_ERROR   = 'CLOUD_CONTENT_ERROR'

export const BUCKET_CONTENT_PENDING = 'BUCKET_CONTENT_PENDING'
export const BUCKET_CONTENT_SUCCESS = 'BUCKET_CONTENT_SUCCESS'
export const BUCKET_CONTENT_ERROR   = 'BUCKET_CONTENT_ERROR'

export const SELECT_BUCKET         = 'SELECT_BUCKET'
export const RESET_CLOUD_FC        = 'RESET_CLOUD_FC'

export const DEFAULT_CONTENT_LIMIT = 100

export const selectBucket = (bucket, current_path) => ({
  type         : SELECT_BUCKET,
  bucket       : bucket,
  current_path : current_path
})

export const reset_cloud_fs = () => ({
  type : RESET_CLOUD_FC
})

export function fetchBucketContent({bucket, current_path, content_limit, last_file}) {
  return dispatch => {
    if(!bucket){
      return
    }

    dispatch(requestData(BUCKET_CONTENT_PENDING))

    CloudFlyerAPI
      .storages
      .getFilesByPath(bucket.id, current_path ? current_path : '/', content_limit ? content_limit : DEFAULT_CONTENT_LIMIT, last_file)
      .then(response => {
        /*if(!(response||{}).data || !(response||{}).data.item){
          return dispatch(receiveError(BUCKET_CONTENT_ERROR, {bucket, current_path, content_limit, last_file}))
        }*/
        dispatch(receiveData(BUCKET_CONTENT_SUCCESS, {...((response||{}).data||{}), bucket, current_path, content_limit, last_file}))
      })
      .catch((err) => {
        dispatch(receiveError(BUCKET_CONTENT_ERROR, err))
      })
  }
}
